<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
          <h1>Assunto</h1>
          <div class="d-flex">
            <!-- <div class="switch-container">
              <span class="switch-label mr-1">Destaque</span>
              <toggle-button class="mb-0 mr-3" v-model="form.highlight" :width="80" :height="25"
                             :labels="{ checked: 'ATIVO', unchecked: 'INATIVO'}"/>
            </div> -->
            <div class="switch-container">
              <span class="switch-label mr-1">Status</span>
              <toggle-button class="mb-0 mr-3" v-model="form.status" :width="80" :height="25"
                             :labels="{ checked: 'ATIVO', unchecked: 'INATIVO'}"/>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="Título*" label-for="name">
              <b-form-input id="name" placeholder="Título" required v-model="form.name" type="text" :class="{'is-invalid': form.errors.has('name')}"></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group label="Emails*" label-for="emails" description="E-mail que receberá os formulários desse assunto">
              <b-form-input id="emails" placeholder="Emails" required v-model="form.emails" type="text" :class="{'is-invalid': form.errors.has('emails')}"></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>
      <div class="card-footer text-right">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import slugify from 'slugify'
  import {slugifyOptions} from '@/plugins'

  export default {
    name: 'InsuranceDestination',
    props: {
      form: {
        type: [Object],
        required: true
      },
      submitted: {
        type: Boolean,
        default: false
      },
      instance: {
        type: Object,
        default () {
          return {
            media: []
          }
        }
      },
      http: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        empty: {
          name: '',
          emails: '',
          status: true,
          highlight: false
        }
      }
    },

    methods: {
      slugify () {
        const self = this

        if (this.userEditedSlug) {
          return
        }

        self.show = false
        self.form.slug = slugify(self.form.name, slugifyOptions)
        self.$nextTick(() => {
          self.show = true
        })
      },

      title () {
        this.$forceUpdate()
      }
    },

    created () {
      const self = this

      self.form.withData(self.instance.id ? self.instance : self.empty)
        .setInitialValues(self.instance.id ? self.instance : self.empty)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/forms/Rte/Subject.vue